
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Modal } from 'semantic-ui-react'
import { getHasError, getError, getUiMessage } from '../selectors'
import { setError } from '../actions'


class ErrorMessageDialog extends React.Component {
    state = { open: this.props.hasError }

    close = () => {
        this.setState({ open: false })
        this.props.clearError()
    }

    componentWillReceiveProps(nextProp) {
        this.setState({ open: nextProp.hasError })
    }

    mapErrorUnprocessableEntity = (errors) => {
        // console.log('5555', Object.keys(errors))
        let text = []
            , keys = Object.keys(errors)
        keys.forEach(key => {
            const { msg, param } = errors[key]
            text.push(
                <p className='user-font-weight500 user-no-margin'>{msg} - {param}</p>
            )
        })
        return text
    }

    render() {
        // const { hasError, error } = this.props
        const { errorCode, errorMessage /*, statusText*/ } = this.props.uiError
        return (
            <Modal open={this.state.open} onClose={this.close}>
                <Modal.Header><h3 className='user-font-weight700'>System Message</h3></Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <p>Error Code : {errorCode}</p>
                        <p>Error Message : {errorMessage}</p>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        className="buttonSubmit"
                        onClick={this.close}>Ok</Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default compose(
    connect(
        (state, props) => ({
            hasError: getHasError(state),
            error: getError(state),
            uiError: getUiMessage(state),
        }),
        (dispatch) => ({
            clearError() {
                dispatch(setError(false))
            },
        })
    )
)(ErrorMessageDialog)


// WEBPACK FOOTER //
// ./src/front/features/ui/components/ErrorMessageDialog.js